<template>
  <div>
    <countries-chart
      class="main-window"
      v-if="sector === 'countries'"
      :data="data"
      @timeFrame="emitTimeFrame"
      :sorted-by="sortedBy"
    />
  </div>
</template>

<script>
import countriesChart from "./countriesCharts/countriesChart";
export default {
  name: "multiSelectGraph.container",
  components: {
    countriesChart
  },
  props: {
    sortedBy: {
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    sector: {
      type: String,
      required: true
    },
    subSector: {
      type: String,
      required: true
    }
  },
  methods: {
    emitTimeFrame(val) {
      this.$emit("timeFrame", val);
    }
  }
};
</script>

<style scoped>
.main-window {
  position: center;
  min-width: 100%;
  height: 210px;
}
</style>
